import React from 'react';
import CmtVertical from '../../../../@coremat/CmtNavigation/Vertical';
import PerfectScrollbar from 'react-perfect-scrollbar';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IntlMessages from '../../../../util/IntlMessages';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import NotesIcon from '@material-ui/icons/Notes';
import PaymentIcon from '@material-ui/icons/Payment';
import BallotIcon from '@material-ui/icons/Ballot';

const useStyles = makeStyles((theme) => ({
  perfectScrollbarSidebar: {
    'height': '100%',
    // paddingTop: 10,
    'transition': 'all 0.3s ease',
    '.Cmt-sidebar-fixed &, .Cmt-Drawer-container &': {
      height: 'calc(100% - 167px)',
    },
    '.Cmt-modernLayout &': {
      height: 'calc(100% - 72px)',
    },
    '.Cmt-miniLayout &': {
      height: 'calc(100% - 91px)',
    },
    '.Cmt-miniLayout .Cmt-sidebar-content:hover &': {
      height: 'calc(100% - 167px)',
    },
  },
}));

const SideBar = () => {
  const classes = useStyles();
  const navigationMenus = [
    {
      name: <IntlMessages id={'General'} />,
      icon: <AccountCircleIcon />,
      type: 'item',
      link: '/',
    },
    {
      name: <IntlMessages id={'Notes'} />,
      icon: <NotesIcon />,
      type: 'item',
      link: '/account-summary',
    },
    {
      name: <IntlMessages id={'Account Details'} />,
      icon: <DashboardIcon />,
      type: 'item',
      link: '/account-summary',
    },
    {
      name: <IntlMessages id={'Account Multiples'} />,
      icon: <BallotIcon />,
      type: 'item',
      link: '/patient-search',
    },
    {
      name: <IntlMessages id={'Payments'} />,
      icon: <PaymentIcon />,
      type: 'item',
      link: '/patient-search',
    },
  ];

  return (
    <div className="sideBar">
      <PerfectScrollbar className={classes.perfectScrollbarSidebar}>
        <CmtVertical menuItems={navigationMenus} />
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
